<template>
  <div class="login">

    <div class="container">
      <img class="logo" src="@/assets/images/logo.png" alt="Logo VCPODE" />

      <h3 v-if="codeShow" style="color: var(--primary); text-align: center;">Recupere sua senha</h3>
      <h3 v-else style="color: var(--primary); text-align: center;">Administrativo</h3>

      <v-form v-if="!codeShow"  @submit.prevent="doLogin">
        <v-text-field
          v-model="username" 
          label="Usuário"
          type="text"
          variant="solo"
          autocomplete="username"
          required
          data-test="login-input-username"
        />
        <v-text-field
          v-model="password" 
          label="Senha"
          :type="isPasswordVisible ? 'text' : 'password'" 
          :append-inner-icon="isPasswordVisible ? 'mdi-eye': 'mdi-eye-off'"
          @click:append-inner="isPasswordVisible = !isPasswordVisible"
          variant="solo"
          autocomplete="current-password"
          required 
          data-test="login-input-senha"
        />

        <v-btn 
          :loading="doingLogin" 
          color="primary" 
          type="submit" block
          data-test="login-button"
        >
          Entrar
        </v-btn>

        <v-row justify="center" class="mt-2">
          <v-col cols="auto" class="noticeBox">
            <span>Esqueceu a senha? Digite seu email e </span>
            <a href="#" @click.prevent="forgot" data-test="forgot-link-password">Clique aqui</a>
          </v-col>
        </v-row>
      </v-form>

      <v-form v-else  @submit.prevent="newPassword">
        <v-text-field
          v-model="code"
          label="Código"
          type="text"
          variant="solo"
          required
          disabled
        />

        <v-text-field
          v-model="username"
          label="Email"
          type="text"
          variant="solo"
          autocomplete="username"
          required
          data-test="forgot-input-username"
        />

        <v-text-field
          v-model="password"
          label="Nova Senha"
          :type="isPasswordVisible? 'text': 'password'"
          :append-inner-icon="isPasswordVisible ? 'mdi-eye': 'mdi-eye-off'"
          @click:append-inner="isPasswordVisible = !isPasswordVisible"
          variant="solo"
          autocomplete="current-password"
          required
          data-test="forgot-input-new-password"
        />
        <v-text-field
          v-model="confirmPassword"
          label="Confirme a Nova Senha"
          :type="isPasswordVisible? 'text': 'password'"
          :append-inner-icon="isPasswordVisible ? 'mdi-eye': 'mdi-eye-off'"
          @click:append-inner="isPasswordVisible = !isPasswordVisible"
          variant="solo"
          autocomplete="current-password"
          required
          data-test="forgot-input-confirm-new-password"
        />
        <small style="text-align: center;">A senha deve ter pelo menos 8 caracteres, incluindo 1 caractere especial, 1 letra maiúscula, 1 letra minúscula e 1 número.</small>

        <v-btn 
          :loading="doingLogin" 
          color="primary" 
          type="submit" 
          block
          data-test="forgot-alter-button"
        >
          Alterar
        </v-btn>
      </v-form>

    </div>

    <VueToast :toast="toast" />
    
  </div>
</template>

<script>
import VueToast from "@/components/VueToast.vue";
import { validateEmail } from '@/services/utils.js';
import { cnpj, cpf } from 'cpf-cnpj-validator';
import { users } from "../services";

export default {
  name: "LoginView",

  components: {
    VueToast,
  },

  data() {
    return {
      isPasswordVisible: false,
      doingLogin: false,
      codeShow: true,
      code: "",
      username: "",
      password: "",
      confirmPassword: '',

      toast: {},
    };
  },

  methods: {
    async newPassword() {

      try{
        if(!this.password || !this.confirmPassword || !this.username){
          this.toast = { 
              show: true, 
              message: "Todos os campos devem ser preenchidos", 
              type: "error" 
            };
          return;
        }

        const username = this.detectUsernameType(this.username);
        if (!username) {
          this.toast = {
            show: true,
            type: "error",
            message: "Por favor, insira seu Usuário.",
          };
          return;
        }

        if(this.password !== this.confirmPassword) {
            this.toast = { 
                show: true, 
                message: "A senha e a confirmação precisam ser iguais", 
                type: "error" 
              };
            return;
          }

        const payload = { 
          email: username, 
          code: this.code, 
          new_password: this.password 
        }
        await users.newPassword(payload);
        this.toast = {
          show: true,
          type: "success",
          message: "Senha alterada com sucesso.",
        };
        this.codeShow = false;
        this.doLogin();
      }
      catch (error) {
        console
        this.toast = {
          show: true,
          type: "error",
          message: "Não foi possível alterar a senha. Favor verificar o preenchimento dos campos e a explicacão do código.",
        };
      } finally {
        setTimeout(() => {this.toast.show= false}, 3000)
      }
    },

    async forgot() {
      if (!this.username) {
        this.toast = {
          show: true,
          type: "error",
          message: "Por favor, insira seu Usuário.",
        };
        return;
      }

      try {
        await users.forgotPassword({ email: this.username });
        this.toast = {
          show: true,
          type: "success",
          message: "Um email foi enviado para você com as instruções para recuperar sua senha.",
        };
    } catch (error) {
      this.toast = {
        show: true,
        type: "error",
        message: "Não foi possível enviar as instruções para recuperação de senha. Tente novamente mais tarde.",
      };
    }
    },

    async doLogin() {
      this.doingLogin = true;

      try {
        const username = this.detectUsernameType(this.username);
        if (!username) {
          this.toast = {
            show: true,
            type: "error",
            message: "Por favor, insira seu Usuário.",
          };
          return;
        }

        if (!this.password) {
          this.toast = {
            show: true,
            type: "error",
            message: "Você precisa digitar sua senha.",
          };
          return;
        }
        
        const { data } = await users.login({
          username: username,
          password: this.password,
        });
        
        if (data.user.profile.toLowerCase() === "admin") {
          localStorage.setItem("user", JSON.stringify(data));
          localStorage.setItem('idToken', data.idToken)
          this.$router.push("/home");
        } else {
          this.$router.push("/");

          this.toast = {
            show: true,
            type: "error",
            message: "Usuário não autorizado.",
          };
        }
        
      } catch (error) {
        this.toast = {
          show: true,
          type: "error",
          message: "Usuário ou senha inválidos.",
        };
      } finally {
        this.doingLogin = false;
        setTimeout(() => {this.toast.show= false}, 3000)
      }
    },

    detectUsernameType(username) {
			const value = (username || "").trim();

			if (cpf.isValid(value)) {
				return cpf.format(value);
			}

			if (cnpj.isValid(value)) {
				return cnpj.format(value);
			}

      if(validateEmail(value)){
        return value.toLowerCase();
      }
		}

  },

  mounted(){
    const params = new URLSearchParams(window.location.search);
    const param = params.get('code');
    this.code = param;
    if(this.code){
      this.codeShow = true;
    } else {
      this.codeShow = false
    }
  }
};
</script>

<style lang="scss" scoped>
.login {
  width: 100vw;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;

  .container {
    width: 100%;
    max-width: 520px;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 2rem;
    background-color: var(--standard);
    border-radius: 1rem;
    padding: 2rem 1rem;

    .logo {
      width: 100%;
      max-width: 250px;
    }

    form {
      width: 100%;
      display: flex;
      flex-direction: column;

      button {
        margin-top: 1.5rem;
        background-color: var(--primary) !important;

        &:hover {
          background-color: var(--light-text) !important;
          color: var(--primary) !important;
          border: 2px solid var(--primary)
        }
      }

      .noticeBox {
        color: var(--light-text);
        a {
          color: var(--primary);
          &:hover {
            color: var(--error-message);
          }
        }
      }
    }
  }

}


</style>
